/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Name/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Name({
  children,
  viewPath = "/DesignSystem/DataVaxiomInsuranceBillingCenter/Name",
  isInvalid,
  onChange
  
}) {
let billingCenterNameValueData = fromData.useDataValue({ viewPath,
context: 'billing_center',
path: 'name',
})
let billingCenterNameIsValidData = fromData.useDataIsValid({ viewPath,
context: 'billing_center',
path: 'name',
validate: fromValidate.textInput,
required: true,
})
let billingCenterNameChangeData = fromData.useDataChange({ viewPath,
context: 'billing_center',
path: 'name',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="billing_center.name"
 validate="/Data/validate.js textInput"
 invalid={!billingCenterNameIsValidData}
 required={true}
 value={billingCenterNameValueData}
 onChange={billingCenterNameChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Name"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}